import React, { Component } from 'react';
import styles from './styles.scss';

class WMask extends Component 
{
  // 設計用來撐滿div
  render() 
  { 
    return (
        <div className={styles.mask}>
          <div className={styles.content}>
            { this.props.children}
            { this.props.title }
          </div>
        </div>
    );
  }
}

export default WMask;



// WEBPACK FOOTER //
// ./src/components/WMask/WMask.js